<template>
    <section class="desktop-category-header">
        <section v-if="sections" class="category-list no-affix d-block">
            <div class="category-list-inner">
                <ul class="nav-list">
                    <li v-for="section in sections" class="nav-item">
                        <a class="nav-link" :href="section.url">{{ section.name }}</a>
                    </li>
                </ul>
            </div>
        </section>

        <div class="desktop-category-filters desktop-category-filters--desktop">
            <div class="desktop-category-filters-wrap">
                <div v-for="(filter, index) in filterList"
                     :key="`filter-${index}`"
                     v-if="hasFilterValues(filter.slug) && !mustBeSkipped(filter.slug)"
                     class="filter"
                     :class="{ active: hasSelected(filter.slug), show: isActive(filter.slug)  }"
                     :id="`catalog-filter-${filter.slug}`">
                    <button class="filter-toggle" :id="`filter-${filter.slug}`"
                            type="button"
                            aria-haspopup="true"
                            :aria-expanded="isActive(filter.slug)"
                            :data-boundary="`catalog-filter-${filter.slug}`"
                            @click.prevent="toggle(filter.slug)">
                        <span class="filter-name">{{ filter.name + (filter.slug === 'price' ? ', &#8381;' : '') }}</span>
                        <span class="filter-clear" @click.prevent="clearFilterSelection(filter.slug)">Сбросить</span>
                        <span class="filter-arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px"
                                 viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                                <polygon fill=""
                                         points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229"></polygon>
                            </svg>
                        </span>
                    </button>
                    <filter-item :filter="filter"></filter-item>
                </div>
            </div>
        </div>
        <div class="category-filters category-filters--mobile">
            <q-btn class="filter-categories" outline @click.prevent="openDialogCategoriesMobile()"
                   style="margin-right: 10px;">Категории</q-btn>
            <q-btn class="filter-options" outline
                   @click.prevent="openDialogFiltersMobile()"><span v-if="totalSelected" class="badge">{{ totalSelected }}</span>Фильтры</q-btn>
        </div>
        <modal-categories></modal-categories>
        <modal-filters classes="filter-model"></modal-filters>
    </section>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import FilterItem from './../../Catalog/Filter/Item'
import ModalCategories from "./../../Catalog/Modals/Categories"
import ModalFilters from "./../../Catalog/Modals/Filters"

export default {
    name: 'CatalogFilters',
    components: {
        FilterItem,
        ModalCategories,
        ModalFilters,
    },
    data() {
        return {
            lastChanged: '',
            showSort: false,
            isSliderChanged: false,
            categoriesListMobile: false,
            dialogFiltersMobile: false,
            dialogFilterMobile: false,
            maximizedToggle: true,
            dialogCategoriesMobile: false,
            totalSelected: 0,
            selectedFilterMobile: [],
            selectedFilterMobileTitle: "",
        }
    },
    mounted() {
        this.setActive(this.filterList.filter(filter => filter.open_by_default).map(filter => filter.slug))
        this.totalSelected = this.allSelectedCount()
    },
    watch: {
        isReady(value) {
            if (value) {
                this.totalSelected = this.allSelectedCount()
            }
        },
        selected: {
            handler(val, oldVal) {
                if (!this.rangeFilters.includes(this.lastChanged)) {
                    this.applyFilters()
                }
            },
            deep: true
        },
    },
    computed: {
        ...mapState('catalog', [
            'selected',
            'sortOptions',
            'rangeFilters',
            'categoryId',
            'filterList',
            'activeSelected',
            'filters',
            'sections',
            'active',
        ]),
        ...mapGetters('catalog', [
            'selectedCategory',
            'isReady',
            'selectedSortOption',
            'changed',
            'filterValues',
            'hasFilterValues',
            'mustBeSkipped',
            'getCategoryById',
            'isActive',
            'isSlider'
        ]),
        categories() {
            if (this.selectedCategory) {
                if (this.selectedCategory.subCategories.length) {
                    return this.selectedCategory.subCategories
                }
                return [this.selectedCategory]
            }

            let categories = this.$store.state.catalog.categories
            return categories.length === 1 && categories[0].subCategories.length ? categories[0].subCategories : categories
        },
        parentCategory() {
            if (this.selectedCategory && !_.isEmpty(this.selectedCategory.parent)) {
                return this.selectedCategory.parent
            }
            return false
        }
    },
    methods: {
        ...mapActions('catalog', [
            'applyFilters',
            'clearFilterSelection',
            'clearAllFilterSelection',
        ]),
        ...mapMutations('catalog', [
            'setActive',
            'toggleDialogFiltersMobile',
            'toggleDialogCategoriesMobile',
        ]),
        openDialogFiltersMobile() {
            this.toggleDialogFiltersMobile(true)
        },
        openDialogCategoriesMobile() {
            this.toggleDialogCategoriesMobile(true)
        },
        toggle(filter) {
            let active = this.active;
            if (this.isReady) {
                if (this.active.includes(filter)) {
                    active = active.filter(f => f !== filter)
                } else {
                    active.push(filter)
                }
            } else {
                active = active.filter(f => f !== filter)
            }
            this.setActive(active)
        },
        hasSelected(filter) {
            return this.selected[filter] && !_.isEmpty(this.selected[filter])
        },
        selectedCount(filter) {
            if (this.selected[filter] && !['dir', 'code', 'page'].includes(filter)) {
                return this.isSlider(filter) || filter === 'sort'
                    ? 1
                    : this.selected[filter].length
            }
            return 0;
        },
        allSelectedCount() {
            let count = 0

            for (let prop in this.selected) {
                if (prop !== 'category') {
                    count += this.selectedCount(prop);
                }
            }
            return count
        },
    }
}
</script>

